import { Dimensions, Text, TouchableOpacity, View } from "react-native"
import React, { useEffect, useState } from "react"
import styles from "./styles"
import Modal from "react-native-modal"
import { baseColors } from "@Constants/baseStyles"
import { Button } from "@Components/CustomButton/Button"
import { RFValue } from "react-native-responsive-fontsize"
import * as Linking from "expo-linking"
import SvgVideoCall from "@Components/CustomIcon/SvgVideoCall"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { useNavigation } from "@react-navigation/native"

const VisioCallModal = ({ open, toggleModal, setOpenVisio, educationalDiagnosisVisio }) => {
    const [iframeData, setIframeData] = useState("")
    const [started, setStarted] = useState(false)
    useEffect(() => {
        if (educationalDiagnosisVisio?.visioconference?.id > 0) {
            setIframeData(educationalDiagnosisVisio?.visioconference)
        }
    }, [educationalDiagnosisVisio])

    const openCallWithBrowser = () => {
        Linking.openURL(iframeData?.url).then(() => {
            setStarted(true)
        })
    }

    const navigation = useNavigation()
    const joinRoom = () => navigation.navigate("AppointmentVisioContent")

    return (
        <Modal
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            animationOutTiming={10}
            //onDismiss={toggleModal}
            isVisible={open}
            onSwipeComplete={toggleModal}
            onBackButtonPress={toggleModal}
            style={styles.container}
        >
            <View
                style={{
                    width: "100%",
                    height: Dimensions.get("screen").height / 1.5,
                    position: "relative",
                    overflow: "visible",
                    backgroundColor: "transparent",
                    borderRadius: 5
                }}
            >
                <View>
                    <SvgVideoCall style={{ top: 20, alignSelf: "center" }} height={200} width={200} />

                    <View style={{ alignItems: "center", marginTop: 50 }}>
                        <BreeSerifText style={{ textAlign: "center", color: baseColors.orange.light, fontSize: 25 }}>
                            Vous avez un rendez-vous en attente.
                        </BreeSerifText>
                    </View>
                </View>

                {started ? (
                    <View
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1
                        }}
                    >
                        <Button
                            onPress={toggleModal}
                            text="Terminer"
                            height={RFValue(50)}
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                            style={{ paddingHorizontal: 50 }}
                        />
                    </View>
                ) : (
                    <View
                        style={{
                            flex: 1,
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Button
                            onPress={toggleModal}
                            text="Annuler"
                            height={RFValue(50)}
                            backgroundColor={baseColors.orange.primary}
                            labelColor={"white"}
                            style={{ flex: 0.45 }}
                        />

                        <Button
                            onPress={joinRoom}
                            text="Commencer"
                            height={RFValue(50)}
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                            style={{ flex: 0.45 }}
                        />
                    </View>
                )}
            </View>
        </Modal>
    )
}

export default VisioCallModal
